/* eslint-disable  no-unused-vars, no-undef */
jQuery(function ($) {
	$(window).on('popstate', function () {
		location.reload(true);
	});

	const $wrapper = $('#wrapper');

	$('html').on('click', function (e) {
		setTimeout(function () {
			const clickX = e.pageX;
			const clickY = e.pageY;

			if (isHotels() && isCloseFront()) {
				const hotel = getActiveHotel();

				if (isProfile()) {
					const closeFunction = `hide_hotel_details_${hotel}`;
					window[closeFunction].call(null);
				} else if (hotel) {
					const hotelId = hotel === 'hypernym' ? 'wide' : hotel;
					const $hotel = $(`#${hotelId}`);
					if ($hotel.length > 0) {
						let hotelX = $hotel.offset().left;
						let hotelY = $hotel.offset().top;
						let hotelW = $hotel.width();
						let hotelH = $hotel.height();

						switch (hotel) {
							case 'wide':
								hotelW = hotelW * 0.58199847445;
								hotelY += hotelH * 0.239634146;
								hotelH = hotelH * (1 - 0.239634146);
								break;
							case 'hypernym':
								hotelX += hotelW * (1 - 0.423340961);
								hotelW = hotelW * 0.423340961;
								break;
						}

						/*
						console.log("clickX = " +  clickX);
						console.log("clickY = " +  clickY);
						console.log("hotelX = " +  hotelX);
						console.log("hotelY = " +  hotelY);
						console.log("hotelW = " +  hotelW);
						console.log("hotelH = " +  hotelH);
						*/

						if (
							!(
								clickX >= hotelX &&
								clickX <= hotelX + hotelW &&
								clickY >= hotelY &&
								clickY <= hotelY + hotelH
							)
						) {
							clear_all_thehotels();
						}
					} else {
						console.error(`Hotel element #${hotelId} not found.`);
					}
				}
			}
		}, 20);
	});

	$(
		'.hotel-image,.visit-hotel-button,.all-hotels,.top-navigation,.close-hotel-area,#all-pointers,#all-hotels-logos'
	).on('click', function (e) {
		e.stopPropagation();
	});

	function isLoading() {
		return $wrapper.hasClass('loading');
	}

	function isHotels() {
		return $wrapper.hasClass('section-thehotels');
	}

	function isCloseFront() {
		return $wrapper.hasClass('section-thehotels');
	}

	function getActiveHotel() {
		const matches = $wrapper.attr('class').match(/active-([^ ]*)/);
		let hotel = matches ? matches[1] : '';

		if (hotel === '57house') {
			hotel = 'house57';
		}

		return hotel;
	}

	function isProfile() {
		return $wrapper.attr('class').match(/active-([^-]*)-profile/);
	}
});
